import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { SharedUiElementsModule } from '@planone/shared/ui-elements';
import { SwiperModule } from 'swiper/angular';

import { SwiperComponent } from './swiper/swiper.component';
import { SwiperZoomModalComponent } from './swiper-zoom-modal/swiper-zoom-modal.component';
import { VideoSwiperComponent } from './video-swiper/video-swiper.component';
import { VideoSwiperZoomModalComponent } from './video-swiper-zoom-modal/video-swiper-zoom-modal.component';

@NgModule({
  imports: [CommonModule, SwiperModule, MatDialogModule, MatIconModule, SharedUiElementsModule],
  exports: [SwiperComponent, SwiperZoomModalComponent, VideoSwiperComponent, VideoSwiperZoomModalComponent],
  declarations: [SwiperComponent, SwiperZoomModalComponent, VideoSwiperComponent, VideoSwiperZoomModalComponent],
})
export class SharedUiSwiperModule {}
